import React from 'react';
import { observer } from 'mobx-react'
import { styled } from "../../stitches.config"
import SocialButtonLike from "../atoms/SocialButtonLike"
import SocialButtonComment from "../atoms/SocialButtonComment"
import SocialButtonShare from "../atoms/SocialButtonShare"
import { useStores, pushDataLayer } from "../../helpers"

import { IS_FEATURE_enableComments } from "../../components/common/constants/constants";
interface SocialIconsProps {
    article: ArticleAuthor;
}

const SocialIcons: React.FC<SocialIconsProps> = observer(() => {
    const { ArticleStore } = useStores();
    const stats = ArticleStore.article.stats || {};
    const url = ArticleStore.article.fb_url;

    return (

        <StyledSocialIcons>
            <div className="container row">
                <div className="col-md-12">
                    <SocialButtonLike url={url} number={stats.likes} showText={true} />
                    {IS_FEATURE_enableComments && <SocialButtonComment number={stats.comments} showText={true} />}
                    <SocialButtonShare url={url} number={stats.shares} showText={true} />
                </div>
            </div>
        </StyledSocialIcons>

    );
});

const StyledSocialIcons = styled('div', {
    width: "100%",
    display: "none",
    "@bp4": {
        display: "block",
    },
    "& .container": {
        overflowY: "visible !important"
    },
    ".container": {
        "&:before": {
            content: "",
        },
        "&:after": {
            content: "",
        },
    }
    ,
    "& .col-md-12": {
        padding: 0,
        display: "flex",
        "& div, a": {
            marginRight: "8px",
            "@bp4": {
                marginRight: "24px",
            }
        },
    }
})

export default SocialIcons